import axios from "axios";
import Cookies from "js-cookie";
import apiUrl from "../utility/apiUrl";

const authHeaders = () => ({ Authorization: Cookies.get("token") });

export const getShortlist = () =>
  axios.get(`${apiUrl}/api/v1/student/shortlist`, { headers: authHeaders() });

export const getShortlistIds = () =>
  axios.get(`${apiUrl}/api/v1/student/shortlist/ids`, { headers: authHeaders() });

export const addToShortlist = (collegeId) =>
  axios.post(`${apiUrl}/api/v1/student/shortlist/${collegeId}`, null, { headers: authHeaders() });

export const removeFromShortlist = (collegeId) =>
  axios.delete(`${apiUrl}/api/v1/student/shortlist/${collegeId}`, { headers: authHeaders() });
